import { Endpoint } from '../api.decorators';
import { Field } from '../../util/components/resource/resource-fields/resource-fields';
import { ApiResource } from '../api-resource';
import { WageSchematic } from './lib/wage-schema.interfaces';

@Endpoint('wage-schemas', 'WageSchema')
export class WageSchema extends ApiResource<WageSchema> {
  @Field()
  name!: string;

  @Field()
  validFrom!: Date;

  @Field()
  validUntil!: Date;

  @Field({ readonly: true })
  schema!: WageSchematic;
}
